import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import * as vaultApi from '../../api/vault';
import { RequestLog, VaultRequest } from '../../api/vault';
import LogDetail from './LogDetail';
import LogTree from './LogTree';
import RequestList from './RequestList';
import * as S from './styles';

const RequestsPage = () => {
	//--- HOOKS
	const [searchParams, setSearchParams] = useSearchParams();
	const [requests, setRequests] = useState<VaultRequest[]>([]);
	const [selectedRequest, setSelectedRequest] = useState<VaultRequest | null>(null);
	const [logs, setLogs] = useState<RequestLog[]>([]);
	const [selectedLog, setSelectedLog] = useState<RequestLog | null>(null);
	const [filter, setFilter] = useState(searchParams.get('filter') || '');

	useEffect(() => {
		vaultApi.getRequests({ filter: filter || undefined, count: 100 }).then(setRequests);
	}, [filter]);

	useEffect(() => {
		if (!selectedRequest) {
			setLogs([]);
			setSelectedLog(null);
			return;
		}
		vaultApi.getRequestLogs(selectedRequest.id).then(setLogs);
		setSelectedLog(null);
	}, [selectedRequest]);

	//--- HANDLERS
	const onSelectRequest = useCallback((request: VaultRequest) => {
		setSelectedRequest(request);
	}, []);

	const onSelectLog = useCallback((log: RequestLog) => {
		setSelectedLog(log);
	}, []);

	const onFilterChange = useCallback(
		(newFilter: string) => {
			setFilter(newFilter);
			setSelectedRequest(null);
			if (newFilter) {
				setSearchParams({ filter: newFilter });
			} else {
				setSearchParams({});
			}
		},
		[setSearchParams]
	);

	//--- RENDERING
	return (
		<S.Base>
			<S.LeftPanel>
				<S.PanelHeader>Requests</S.PanelHeader>
				<RequestList
					requests={requests}
					selectedId={selectedRequest?.id ?? null}
					initialFilter={filter}
					onSelect={onSelectRequest}
					onFilterChange={onFilterChange}
				/>
			</S.LeftPanel>
			<S.MiddlePanel>
				<S.PanelHeader>Log Tree</S.PanelHeader>
				<LogTree
					logs={logs}
					selectedId={selectedLog?.id ?? null}
					onSelect={onSelectLog}
				/>
			</S.MiddlePanel>
			<S.RightPanel>
				<S.PanelHeader>Log Detail</S.PanelHeader>
				<S.PanelBody>
					<LogDetail log={selectedLog} />
				</S.PanelBody>
			</S.RightPanel>
		</S.Base>
	);
};

export default RequestsPage;
